module.exports = __webpack_public_path__ + "static/img/1_2_2.ca324593.jpg";